/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Account_HInputs */

const en_funnel_account_h = /** @type {(inputs: Funnel_Account_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your card is saved. Create your account.`)
};

const es_funnel_account_h = /** @type {(inputs: Funnel_Account_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu tarjeta está guardada. Crea tu cuenta.`)
};

/**
* | output |
* | --- |
* | "Your card is saved. Create your account." |
*
* @param {Funnel_Account_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_account_h = /** @type {((inputs?: Funnel_Account_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Account_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_account_h(inputs)
	return en_funnel_account_h(inputs)
});